import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AdvisorPanel } from '../AdvisorPanel/AdvisorPanel.js';
import { _className } from '@nu-art/thunderstorm-frontend/index';
import { PanelKey_ProtocolInfo } from '../../../_shared.js';
import { ICONS } from '@app/styles';
import './AdvisorPanel_ProtocolInfo.scss';
import { scrub } from '@nu-art/ts-common';
import { ModuleFE_AdvisorMini } from '../../../modules/ModuleFE_AdvisorMini.js';
import { contextCloseMode_Safe } from '../../../modules/provide-info/types.js';
import { ModuleFE_ProvideInfo } from '../../../modules/provide-info/ModuleFE_ProvideInfo.js';
import { Component_ProtocolInfo } from '../../components/protocol-info/Component_ProtocolInfo.js';
export class AdvisorPanel_ProtocolInfo extends AdvisorPanel {
    static defaultProps = {
        panelKey: PanelKey_ProtocolInfo,
    };
    //######################### Life Cycle #########################
    __onAdvisorMiniChange = () => {
        if (ModuleFE_AdvisorMini.getIsMiniActive())
            return;
        //Switched from mini to full
        this.forceRefreshStateData();
    };
    __onProvideInfoContextChange = (latestContext) => this.forceRefreshStateData();
    __onProvideInfoContextUpdate = (context) => this.forceRefreshStateData();
    componentDidMount() {
        this.forceRefreshStateData();
    }
    //######################### Logic #########################
    forceRefreshStateData = () => {
        const currentContext = ModuleFE_ProvideInfo.getCurrentProtocolContextData();
        const context = currentContext ? { ...currentContext } : undefined;
        if (!context)
            return;
        // @ts-ignore - Set new context by force outside derive cycle
        this.state.context = context;
        this.forceUpdate();
    };
    getPanelClass() {
        return _className(super.getPanelClass(), 'panel__protocol-info');
    }
    //######################### Render - Header #########################
    renderHeader_Title = () => {
        const context = this.state.context;
        if (!context)
            return 'N/A';
        const style = scrub({ '--protocol-color': context.protocolData.getColor() });
        return _jsxs(_Fragment, { children: [_jsx("div", { className: 'protocol-color', style: style }), context.protocolData.getLabel()] });
    };
    renderHeader_Tail = () => {
        return _jsx(ICONS.advisor_avn_close.component, { onClick: () => ModuleFE_ProvideInfo.context.chain.close(contextCloseMode_Safe) });
    };
    //######################### Render - Sub Header #########################
    renderSubHeader = undefined;
    //######################### Render - Content #########################
    renderContent = () => _jsx(Component_ProtocolInfo, {});
    //######################### Render - Footer #########################
    renderFooter = undefined;
}
//# sourceMappingURL=AdvisorPanel_ProtocolInfo.js.map